var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"fixed-bottom text-right button-row justify-content-center",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"11"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }